import { FaqItem } from '../types'
import { ContentFaq, ContentInline } from './types'

export const inlineText = (nodes: ContentInline[]): string =>
  nodes
    .map((node): string => {
      if (node.kind === 'pending') return ''
      if ('children' in node) return inlineText(node.children)
      return node.text
    })
    .join('')

export const hasPending = (nodes: ContentInline[]): boolean =>
  nodes.some((node) => node.kind === 'pending' || ('children' in node && hasPending(node.children)))

export interface RenderedContentFaq extends FaqItem {
  inline: ContentInline[]
  pending: boolean
}

/** One FAQ array for the accordion and graph; unresolved questions are hidden in both. */
export const contentFaq = (items: ContentFaq[]): RenderedContentFaq[] =>
  items
    .filter(
      ({ question, answer }) => !/\{\{|Dado pendente/.test(question) && !hasPending(answer) && inlineText(answer).trim()
    )
    .map(({ question, answer }) => ({
      question,
      answer: inlineText(answer),
      inline: answer,
      pending: hasPending(answer)
    }))
